module.exports = __webpack_public_path__ + "static/media/plugOff_326.7b5ae738.png";